import { useLocation } from "react-router-dom";

const NullPageComponent: React.FC<{
  heading1?: string;
  heading2?: string;
  heading3?: string;
  button1?: any;
}> = ({ heading1, heading2, heading3, button1 }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  return (
    <div
      className="null-membershipPage-following-tile box"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div className="h-100 d-flex flex-column justify-content-around">
        <div className="text-center z-1">
          <div className="heading h-100 d-flex flex-column justify-content-around">
            <h2>{heading1}</h2>
            <h3>{heading2}</h3>
            <h4>{heading3}</h4>
          </div>
        </div>
        <div className="btn-container">{button1}</div>
      </div>

      {/* Bottom-left blurred effect */}
      <div className="bottom-left-color-effect" />
      {/* Bottom-right blurred effect */}
      {!isHomePage && <div className="bottom-right-color-effect" />}
    </div>
  );
};

export default NullPageComponent;
